export const getStadiumSharedConfig = { site: "stores" };

export function getRequestHost(headersList) {
  // `x-forwarded-host` can be a comma-separated list. We only want the first value.
  const raw = headersList.get("x-forwarded-host") ?? headersList.get("host");
  return raw?.split(",")[0]?.trim() ?? null;
}
